exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-446ea62c] {\n    padding: 7px;\n}\n.badge .close[data-v-446ea62c] {\n    margin-left: .25rem;\n    color: inherit;\n    font-size: 100%;\n    text-shadow: 0 1px 0 rgba(#000, .5);\n}\n[data-toggle=\"collapse\"] .fa[data-v-446ea62c]:before {   \n    content: \"\\F139\";\n}\n[data-toggle=\"collapse\"].collapsed .fa[data-v-446ea62c]:before {\n    content: \"\\F13A\";\n}  \n", ""]);

// exports
